// extracted by mini-css-extract-plugin
export default {"about_content":"About_about_content__bEqOL","header":"About_header__WRNIT","content":"About_content__70Dhc","link":"About_link__sftqg"};